/**
 * 🌍 GLOBAL STANDART KOD (TÜM PROJELER İÇİN GEÇERLİDİR)
 * Core owns navigation disclosure in every shell.
 */
import type { ReactNode } from 'react';

export interface SidebarSectionProps {
  id: string;
  label: string;
  icon: ReactNode;
  arrow: ReactNode;
  isCollapsed: boolean;
  isOpen: boolean;
  hasActiveChild?: boolean;
  onToggle: () => void;
  children: ReactNode;
}

/** The compact desktop rail exposes pages; the expanded drawer exposes groups. */
export function SidebarSection({ id, label, icon, arrow, isCollapsed, isOpen, hasActiveChild, onToggle, children }: SidebarSectionProps) {
  const showPages = isCollapsed || isOpen;
  return (
    <div className="nav-section">
      {!isCollapsed && (
        <button type="button" className={`nav-section-title ${isOpen ? 'open' : ''} ${hasActiveChild ? 'has-active-child' : ''}`}
          onClick={onToggle} title={label} aria-label={label} aria-expanded={isOpen} aria-controls={id}>
          <span className="nav-section-icon" aria-hidden="true">{icon}</span>
          <span className="nav-section-label">{label}</span>
          <span className="nav-section-arrow" aria-hidden="true">{arrow}</span>
        </button>
      )}
      <div id={id} hidden={!showPages} className={`nav-section-content ${showPages ? 'open' : 'closed'}`}>
        {children}
      </div>
    </div>
  );
}
